import * as d3 from 'd3';

// load geojson
export const loadGeoJSON = async () => {
  try {
    const data = await d3.json('/indiana-county.geojson');
    return data;
  } catch (error) {
    console.error('Error loading GeoJSON:', error);
    throw error;
  }
};

// load csv
export const loadTouchpointData = async () => {
  try {
    const data = await d3.csv('/fortress_od_touchpoints_prevalence_frequency_recency_20240321.csv');
    return data;
  } catch (error) {
    console.error('Error loading CSV data:', error);
    throw error;
  }
};

// process csv into county-keyed object, exclude state-level (fips=0)
export const processCountyData = (rawData) => {
  const countyData = {};

  rawData.forEach(row => {
    const fips = row.GEOGRAPHY_FIPS;

    // skip state-level data (fips 0 = indiana aggregate) and empty fips
    if (!fips || fips === '0' || fips === 0) return;

    const county = row.GEOGRAPHY_NAME;
    const year = row.YEAR;
    const touchpointType = row.TOUCHPOINT_TYPE;
    const measureName = row.MEASURE_NAME;
    const measureValue = parseFloat(row.MEASURE_VALUE);

    if (!countyData[fips]) {
      countyData[fips] = {
        fips: fips,
        name: county,
        touchpoints: {}
      };
    }

    if (!countyData[fips].touchpoints[touchpointType]) {
      countyData[fips].touchpoints[touchpointType] = {};
    }

    if (!countyData[fips].touchpoints[touchpointType][year]) {
      countyData[fips].touchpoints[touchpointType][year] = {};
    }

    countyData[fips].touchpoints[touchpointType][year][measureName] = measureValue;

    // This addition is necessary to calculate prevalence.
    // It stores the total decedent count in a predictable place.
    if (measureName === 'Decedent Total Individual Count') {
        if (!countyData[fips].touchpoints['All']) countyData[fips].touchpoints['All'] = {};
        if (!countyData[fips].touchpoints['All'][year]) countyData[fips].touchpoints['All'][year] = {};
        countyData[fips].touchpoints['All'][year][measureName] = measureValue;
    }

  });

  return countyData;
};

// Returns all available years including both numeric years and aggregate periods
export const getAvailableYears = (rawData) => {
  const numericYears = new Set();
  const aggregateYears = new Set();

  rawData.forEach(row => {
    if (row.YEAR) {
      if (/^\d{4}$/.test(row.YEAR)) {
        numericYears.add(row.YEAR);
      } else {
        aggregateYears.add(row.YEAR);
      }
    }
  });

  // Return numeric years sorted first, then aggregate periods
  return [...Array.from(numericYears).sort(), ...Array.from(aggregateYears).sort()];
};

// get unique touchpoint types
export const getTouchpointTypes = (rawData) => {
  const types = new Set();
  rawData.forEach(row => {
  // This prevents our special 'All' key from appearing as a chart category.
    if (row.TOUCHPOINT_TYPE !== 'All') {
      types.add(row.TOUCHPOINT_TYPE);
    }
    
  });
  return Array.from(types).sort();
};

export const processStateData = (rawData) => {
  const stateData = {};
  const stateRows = rawData.filter(row => row.GEOGRAPHY_FIPS === '0');

  stateRows.forEach(row => {
    const year = row.YEAR;
    const touchpointType = row.TOUCHPOINT_TYPE;
    const measureName = row.MEASURE_NAME;
    const measureValue = parseFloat(row.MEASURE_VALUE);

    if (!stateData.touchpoints) {
      stateData.touchpoints = {};
    }
    if (!stateData.touchpoints[touchpointType]) {
      stateData.touchpoints[touchpointType] = {};
    }
    if (!stateData.touchpoints[touchpointType][year]) {
      stateData.touchpoints[touchpointType][year] = {};
    }
    stateData.touchpoints[touchpointType][year][measureName] = measureValue;

    if (measureName === 'Decedent Total Individual Count') {
        if (!stateData.touchpoints['All']) stateData.touchpoints['All'] = {};
        if (!stateData.touchpoints['All'][year]) stateData.touchpoints['All'][year] = {};
        stateData.touchpoints['All'][year][measureName] = measureValue;
    }
  });
  return stateData;
};